import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import CouponModal from "./components/CouponModal";
import { changeQueryString, getParamUrl, historyPushState } from "../../../../utils/url";
import { validateISO8859 } from "../../../../utils/string";
import SectionLoading from "../../../../components/SectionLoading";
import { defer } from "../../../../utils/script";
import { Order } from "../../../../models/Order";
import { getPriceText, stringToPrice } from "../../../../utils/currency";
import { Sticky } from "../../../../utils/sticky";
import { Fee } from "../../../../models/Fee";
import { isMobileByWidth, setStyleElement, isCountryVN } from "../../../../utils/utils";
import DeliveryTime from "./components/DeliveryTime";
import ItemCart from "./components/ItemCart";
import { Product } from "../../../../models/Product";
import { GLOBAL_CONSTANTS } from "../../../../global/constants";
import { DCStatic } from "../../../../models/DCStatic";
import { EVENTS, listenEvent } from "../../../../utils/event";
// eslint-disable-next-line no-unused-vars
import { ReceiptSource } from "../../../../models/ReceiptSource";
import { setTranslateElement } from "../../../../utils/language";

export default class BillingSummary extends DComponent {
  constructor({
    parent,
    id,
    title = "",
    promotionCode,
    referralCode,
    orderCode,
    hideCounpon,
    hasItemCart = true,
    isView,
    isCheckout,
    isFastCheckout,
    orderData = new Order(),
    onContinue = () => { },
    onApplyCode = () => { },
    onTargetLink = () => { },
    defaultLoading,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("BillingSummary", {
        "is-view": isView,
        "is-checkout": isCheckout,
      }),
      title: title ? "[html]" + title : ""
    }, true, defaultLoading);
    this.promotionCode = promotionCode;
    this.referralCode = referralCode;
    this.orderCode = orderCode;
    this.hideCounpon = hideCounpon;
    this.hasItemCart = hasItemCart;
    /**@type {Order} */
    this.orderData = orderData;
    this.onContinue = onContinue;
    this.onApplyCode = onApplyCode;
    this.onTargetLink = onTargetLink;
    this.couponModal = undefined;
    this.isView = isView;
    /**@type {SectionLoading} */
    this.totalLoading = undefined;
    /**@type {DeliveryTime} */
    this.delivery = undefined;
    this.isFastCheckout = isFastCheckout;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "BillingSummary");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.totalLoading = new SectionLoading({ parent: this.parent, zIndex: 999 });
    if (!this.hideCounpon) this.couponModal = new CouponModal({ parent: this.element, orderCode: this.orderCode, promotionCode: this.promotionCode, onApply: (pc) => this.onApplyPromotion(pc) })
    this.delivery = new DeliveryTime({ parent: $(".delivery", this.element) });
    this.addEventListener();
    this.fillData();
    listenEvent(EVENTS.CHANGE_COUNTRY, country => {
      this.setTerm(country);
    })
    if (this.orderData?.orderNo) {
      this.fillTotalBox(this.orderData, false);
    }
  }

  fillData() {
    if (this.promotionCode) this.setPromotionCode(this.promotionCode);
    if (this.referralCode) this.setReferralCode(this.referralCode);
    this.isFastCheckout ? this.element.addClass("is-fast-check") : this.element.removeClass("is-fast-check");
    this.isView ? this.element.addClass("is-view") : this.element.removeClass("is-view");
    if (this.hideCounpon) {
      $(".group-coupon", this.element).addClass("hide")
    } else {
      $(".group-coupon", this.element).removeClass("hide");
      if (this.orderCode && this.couponModal) this.couponModal.setOrderCode(this.orderCode);
    }
  }


  /** @param {Order} orderData */
  fillTotalBox(orderData, isSelectPromotion = true) {
    $(".total-box .item-cart", this.element).html("");
    $(".total-box .fee-box", this.element).html("");


    if (orderData.getSelectedProducts().length > 1) {
      if (this.hasItemCart) {
        orderData.groupSites.forEach((element, index) => {
          // let itemCart = this.genHtmlCart(element, index === orderData.groupSites.length - 1)
          // $(".total-box .item-cart", this.element).append(itemCart);
          if (Product.hasProductSelected(element.products)) {
            new ItemCart({
              parent: $(".total-box .item-cart", this.element),
              productGroupSite: element,
              hasSpace: true
            })
          }
        });
      }
      let totalItems = orderData.getTotalItem();
      orderData.fees.forEach((element) => {
        if (element.amount !== 0) {
          let htmlFee = this.genHtmlFee(element, totalItems);
          $(".total-box .fee-box", this.element).append(htmlFee);
        }
      });
      $(".total-items", this.element).html($.i18n("checkout_totalItem", totalItems.total));
      $(".total-box", this.element).toggleClass("nofee", !orderData.fees?.length);

      if (isSelectPromotion) {
        if ($(".total-box", this.element).find(".item.coupon").length) {
          $(".total-box .item.coupon", this.element).css('cursor', 'pointer');
          $(".total-box .item.coupon", this.element).off("click");
          $(".total-box .item.coupon", this.element).on("click", (e) => {
            e.preventDefault();
            this.onShowPromotions();
          })
        }
      }

      $(".target-link", this.element).off("click");
      $(".target-link", this.element).on("click", (e) => {
        e.preventDefault();
        let target = $(e.currentTarget).attr("target")
        typeof this.onTargetLink == "function" && this.onTargetLink(target);
      })
    } else {
      $(".total-items", this.element).html("");
    }
    $(".cart-total .item.total .value", this.element).html(this.genHtmlTotal(orderData));
  }

  addEventListener() {
    listenEvent(EVENTS.SWITH_THEME, /**@param {ReceiptSource} data */(data) => {
      let { btnCheckoutConfig } = data;
      let { style, text } = btnCheckoutConfig || {}
      if (text) {
        $(".btn-next .continue", this.element).text(text);
        $(".btn-next .checkout", this.element).text(text);
      }
      const btn = $(".btn-next", this.element);
      setStyleElement(btn, style);
      let textStyle = (style || "").split(";").find(s => s.includes("color"));
      setStyleElement(btn.find("span"), textStyle);
    });

    $(".cart-total .btn-next", this.element).on("click", (e) => {
      e.preventDefault();
      typeof this.onContinue == "function" && this.onContinue();
    })

    if (!this.hideCounpon) {
      $(".total-box .open-coupon-modal", this.element).on("click", (e) => {
        e.preventDefault();
        this.onShowPromotions();
      })

      $(".group-coupon .btn-apply", this.element).on("click", (e) => {
        e.preventDefault();
        let id = $(e.currentTarget).attr("id");
        if (id === "btn_apply") {
          $(".group-coupon .form-coupon", this.element).removeClass("is-valid").removeClass("is-invalid");
          let promotionCode = this.getPromotionCode();
          if (promotionCode !== this.promotionCode) {
            this.applyPromotionCode(promotionCode, true);
          }
        }

        if (id === "btn_apply_referral") {
          this.setUpReferralCode(true);
        }
      });

      $(".group-coupon .icon.error", this.element).on("click", (e) => {
        e.preventDefault();
        let id = $(e.currentTarget).attr("id");
        if (id === "error_coupon") {
          $(".group-coupon .form-coupon", this.element).removeClass("is-valid").removeClass("is-invalid");
          let promotion = this.getPromotionCode();
          if (promotion !== "") {
            this.applyPromotionCode("", true);
          }
        }
        if (id === "error_referral_code") {
          $(".group-coupon .form-referral", this.element).removeClass("is-valid").removeClass("is-invalid");
          let referralCode = this.getReferralCode();
          if (referralCode !== "") {
            this.setReferralCode("");
            if (getParamUrl("rc")) {
              this.applyReferralCode(undefined, true);
            }
          }
        }
      });

      $(".group-coupon input", this.element).on("change", (e) => {
        e.preventDefault();
        let id = $(e.currentTarget).attr("id");
        let value = $(e.currentTarget).val();
        if (value !== "") {
          id === "input_coupon" && $(".group-coupon .form-coupon .btn-apply", this.element).attr("disabled", false);
          id === "input_referral_code" && $(".group-coupon .form-referral .btn-apply", this.element).attr("disabled", false);
        }
      });

      $(".group-coupon input", this.element).on("keyup", (e) => {
        e.preventDefault();
        let id = $(e.currentTarget).attr("id");
        let value = $(e.currentTarget).val();
        if (id === "input_coupon") {
          $(".group-coupon .form-coupon", this.element).removeClass("is-valid").removeClass("is-invalid");
          $(".group-coupon .form-coupon .btn-apply", this.element).attr("disabled", value !== "" ? false : true);
          if (value !== "") {
            if (e.keyCode === 13) {
              $(".group-coupon .form-coupon .btn-apply", this.element).trigger('click');
            }
          } else {
            if (this.promotionCode !== "") {
              this.applyPromotionCode("", true);
            }
          }
        }
        if (id === "input_referral_code") {
          $(".group-coupon .form-referral", this.element).removeClass("is-valid").removeClass("is-invalid");
          $(".group-coupon .form-referral .btn-apply", this.element).attr("disabled", value !== "" ? false : true);
          if (value !== "") {
            if (e.keyCode === 13) {
              $(".group-coupon .form-referral .btn-apply", this.element).trigger('click');
            }
          } else {
            if (getParamUrl("rc")) {
              this.applyReferralCode(undefined, true);
            }
          }
        }
      });
    }
    if (!isMobileByWidth() && !this.isView) {
      setTimeout(() => {
        defer(() => $('.box-stick', this.element).offset().top > 0, () => {
          Sticky($('.box-stick', this.element));
        })
      }, 2000);
    }
  }

  /** @param {BillingSummary} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
      this.fillData();
    });
  }

  onApplyPromotion(pc) {
    this.setPromotionCode(pc, true);
    $(".form-coupon #btn_apply", this.element).trigger('click');
    // typeof this.onApplyCode === "function" && this.onApplyCode();
  }

  getPromotionCode() {
    return ($(".form-coupon input", this.element).val() || "").trim();
  }

  setPromotionCode(promption, isApply = false) {
    if (!isApply) this.promotionCode = promption;
    $(".form-coupon input", this.element).val(promption);
    $(".group-coupon .form-coupon .btn-apply", this.element).attr("disabled", !promption ? true : false);
  }

  setPromotion(promotion = {}) {
    if (promotion.codes?.length) {
      this.setPromotionCode(promotion.codes[0]);
    }
    $(".total-box .form-coupon", this.element).addClass(promotion.valid === true ? "is-valid" : promotion.valid === false ? "is-invalid" : "");
    $(".total-box .form-coupon .invalid-feedback", this.element).text(promotion.message || "");
    if (promotion.valid) {
      setTimeout(() => {
        $(".total-box .form-coupon", this.element).removeClass("is-valid");
      }, 3000);
    }
  }

  removePromotion() {
    this.setPromotionCode("");
    $(".total-box .form-coupon", this.element).removeClass("is-valid").removeClass("is-invalid");
    $(".total-box .form-coupon .invalid-feedback", this.element).text("");
  }

  getReferralCode() {
    return ($(".form-referral input", this.element).val() || "").trim();
  }

  setReferralCode(promption) {
    $(".form-referral input", this.element).val(promption);
    $(".group-coupon .form-referral .btn-apply", this.element).attr("disabled", !promption ? true : false);
  }

  setUpReferralCode(isApply = false) {
    let rc = this.getReferralCode();
    if (!rc) {
      return;
    }
    if (rc !== getParamUrl("rc")) {
      if (validateISO8859(rc)) {
        $(".group-coupon .form-referral", this.element).removeClass("is-invalid").addClass("is-valid");
        this.applyReferralCode(rc, isApply);
      } else {
        $(".group-coupon .form-referral", this.element).addClass("is-invalid");
      }
    } else {
      isApply && $(".group-coupon .form-referral", this.element).removeClass("is-invalid").addClass("is-valid");
    }
  }

  applyReferralCode(rc, isApply = false) {
    const url = changeQueryString("rc", rc || undefined);
    historyPushState(url, true);
    isApply && typeof this.onApplyCode == "function" && this.onApplyCode();
  }

  applyPromotionCode(code, isApply = false) {
    this.setPromotionCode(code);
    if (getParamUrl("pc")) {
      const url = changeQueryString("pc", undefined);
      historyPushState(url, true);
    }
    isApply && typeof this.onApplyCode == "function" && this.onApplyCode();
  }

  setMessage(message) {
    if (isMobileByWidth() && message) {
      DCStatic.modalDialog.updateDialog({
        type: GLOBAL_CONSTANTS.DIALOG_TYPE.ERROR,
        icon: require("../../../../assets/images/checkout/warning.jpg"),
        titleI18n: "common_notice",
        descriptionI18n: message,
        btnSubmitI18n: "common_OKBoth",
      });
      DCStatic.modalDialog.show();
    }
    $(".message", this.element).text(message);
  }

  setButtonLoading(isLoading) {
    isLoading ? $(".cart-total .btn-next", this.element).addClass("loading") : $(".cart-total .btn-next", this.element).removeClass("loading");
  }

  setButton(attr, value) {
    $(".cart-total .btn-next", this.element).attr(attr, value);
  }

  setTotalLoading(loading) {
    this.setButtonLoading(loading);
    // defer(() => this.totalLoading, () => {
    //   loading ? this.totalLoading.show() : this.totalLoading.hide();
    // })
  }

  onShowPromotions() {
    this.couponModal.onShow(this.promotionCode);
  }

  setUpDeliveryTime(delivery) {
    defer(() => this.delivery, () => this.delivery.setUpDeliveryTime(delivery));
  }

  setDisplayDelivery(isShow) {
    defer(() => this.delivery, () => this.delivery.setDisplayDelivery(isShow));
  }

  showTotalBox(isShow) {
    defer(() => this.element, () => {
      isShow ? this.element.removeClass("only-show-cart-total") : this.element.addClass("only-show-cart-total");
    });
  }

  setSavingOrder({ amount = 0, cur } = {}) {
    if ($(".saved-money-box").length) {
      $(".saved-money-box").remove();
    }
    $(".total-box .cart-detail", this.element).find(`.item.${Fee.FEE_LIST_ID.SMART}`).remove();

    if (amount > 0) {
      let savingFee = new Fee(Fee.FEE_LIST_ID.SMART, amount, cur);
      if (isMobileByWidth()) {
        $(".main-body").prepend(`<div class="saved-money-box">${this.genSavedMoneyHtml(savingFee)}</div>`);
        let cartHeight = $(".cart-total.mobile", this.element).height();
        cartHeight && $(".saved-money-box").css("bottom", cartHeight + 16 + "px");
      } else {
        $(".total-box .cart-detail", this.element).append(this.genSavedMoneyHtml(savingFee));
      }
    }
  }

  setTextWarningDelivery(text) {
    if (text) {
      $(".warning-delivery", this.element).text(text);
      $(".warning-delivery", this.element).removeClass("hide");
    } else {
      $(".warning-delivery", this.element).addClass("hide");
    }
  }

  setFreeOrder(isFree) {
    isFree ? $(".total-box", this.element).addClass("hide-cart-detail") : $(".total-box", this.element).removeClass("hide-cart-detail");
  }

  setUpRFQ(isRFQ = false) {
    this.setFreeOrder(isRFQ);
    if (isRFQ) {
      this.setDisplayDelivery(false);
    } else {
      this.setDisplayDelivery(true);
    }
  }

  disabledTargetLink(isDisabled = false) {
    isDisabled ? $(".target-link", this.element).addClass("disabled") : $(".target-link", this.element).removeClass("disabled");
  }

  genHtmlFee(fee, totalItems) {
    let total = totalItems.total;
    // ${fee.amount > 0 && ['dutycast_offer_breakdown', 'dutycast_offer'].includes(fee.feeType) ? "-" : ""}

    let amount = stringToPrice(fee.amount);
    return (
      `
      <div class="item ${fee.key}">
        <div class="label${[Fee.FEE_LIST_ID.PROMOTION_FEE_SHIPPING].includes(fee.key) ? " pink" : ""}">
          <span>${fee.title || ""}</span>
          ${['coupon'].includes(fee.key) ? `<img class="icon-coupon" alt="coupon" src="${require("../../../../assets/images/checkout/coupon.svg")}" />` : ""}
          <div class="more-info${!fee.description ? " hide" : ""}">
            <img class="icon info" alt="info" />
            <div class="description-info">
              ${fee.description}
            </div>
          </div>
          ${fee.key === Fee.FEE_LIST_ID.PRODUCTS ? `<span target="order_details" class="target-link disabled">${$.i18n("checkout_totalItem", total)}</span>` : ""}
        </div>
        <div class="value${[1700, 2000].includes(fee.type) ? " blue" : ""}">
          <span class="minus">${fee.amount < 0 ? "-" : ""}</span>
          ${getPriceText(amount, fee.currency)}
        </div>
      </div>
    `
    )
  }

  genSavedMoneyHtml(fee) {
    return (`
      <div class="item ${fee.key} custom-item">
        <img class="custom-icon" alt="" src="${require("../../../../assets/images/checkout/PigSaving.svg")}" />
        <span class="custom-text">
        ${$.i18n("checkout_savedMoney", getPriceText(fee.amount, fee.currency))}
        </span>
      </div>
    `)
  }

  genHtmlTotal(orderData) {
    return getPriceText(orderData.payAmount, orderData.payCurrency)
  }

  setTerm(country) {
    setTranslateElement({
      element: $(".accept-term span", this.element),
      i18nKey: isCountryVN(country) ? "checkout_termAndConditions" : "checkout_termAndConditions2",
      isHtml: true,
    })
  }
}